import handle from './Axios'

export const getMe = (url: string) => {
  try {
    return handle.get(url).then((res) => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export const getNotification = (url: string) => {
  try {
    return handle.get(url).then((res) => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export const getReferral = ([url, id]: [string, string]) => {
  try {
    return handle.get(url + '/' + id).then((res) => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export const getList = (url: string) => {
  try {
    return handle.get(url).then((res) => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export const getCheckedIn = (url: string) => {
  try {
    return handle.get(url).then((res) => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export default { getMe, getNotification, getReferral, getList, getCheckedIn }
